// extracted by mini-css-extract-plugin
export default {"controlSlider":"slider-component_controlSlider__yG7yG","win10-thumb":"slider-component_win10-thumb__EAmWy"};